import { system } from '@workday/canvas-tokens-web'

// `baseStyle` receives `props.theme`, so `bodySemi` is read from the active theme. Flag-ON
// (sanaRebrandTextStyles) `bodySemi` already carries the default text color; flag-OFF the
// legacy `bodySemi` is colorless, so the explicit color stays as the flag-OFF fallback —
// fg.default, the same value the legacy `--vndly-color-input-text-label` resolved to.
export const FormLabel = {
  baseStyle: ({ theme }) => ({
    ...theme.textStyles.bodySemi,
    color: `var(${system.color.fg.default})`,
    mb: 1
  })
}
